/** Mirrors the backend AuthDtos. Kept in one file so a backend change has one place to land. */

export interface PermissionSet {
  view: boolean
  add: boolean
  edit: boolean
  delete: boolean
}

export interface UserProfile {
  id: number
  email: string
  name: string
  roleId: string
  roleName: string
  companyCode: string | null
  profilePicture: string | null
  branchIds: string[]
}

export interface LoginResponse {
  accessToken: string
  tokenType: string
  expiresIn: number
  profile: UserProfile
  permissions: Record<string, PermissionSet>
}

export type PermissionAction = keyof PermissionSet

/** Permission codes, matching the SPB_PERMISSION seed. Treated as API. */
export const PERM = {
  PORTAL_BILLING: 'PORTAL_BILLING',
  PORTAL_MONITORING: 'PORTAL_MONITORING',
  BILLING_PROFORMA: 'BILLING_PROFORMA',
  BILLING_CUSTOMER: 'BILLING_CUSTOMER',
  BILLING_APPROVAL: 'BILLING_APPROVAL',
  BILLING_INVOICE: 'BILLING_INVOICE',
  BILLING_RECON: 'BILLING_RECON',
  BILLING_MATRIX: 'BILLING_MATRIX',
  /** view: the Rekening Penerimaan page; edit: switching accounts, the default, and syncing. */
  BILLING_BANK_ACCOUNT: 'BILLING_BANK_ACCOUNT',
  BILLING_ADMIN: 'BILLING_ADMIN',
  PORTAL_PIUTANG: 'PORTAL_PIUTANG',
  /** view: list and detail; edit: cover letter, shipment, upload, payment note; delete: remove a document. */
  PIUTANG_INVOICE: 'PIUTANG_INVOICE',
  /** edit: confirmation letters, other collection steps, receivable status. */
  PIUTANG_COLLECTION: 'PIUTANG_COLLECTION',
  /** edit: client group, relation and billing email. */
  PIUTANG_CLIENT: 'PIUTANG_CLIENT',
  /** view: the Pengaturan surat page; edit: saving it and sending a test email. */
  PIUTANG_SETTINGS: 'PIUTANG_SETTINGS',
} as const

/** What each permission is called on screen. Codes are for the API, not for people. */
export const PERM_LABEL: Record<string, string> = {
  PORTAL_BILLING: 'SIPAY Billing',
  PORTAL_MONITORING: 'SIPAY Monitoring',
  BILLING_PROFORMA: 'Proforma',
  BILLING_CUSTOMER: 'Master Pelanggan',
  BILLING_APPROVAL: 'Persetujuan',
  BILLING_INVOICE: 'Invoice',
  BILLING_RECON: 'Rekonsiliasi',
  BILLING_MATRIX: 'Matriks Persetujuan',
  BILLING_BANK_ACCOUNT: 'Rekening Penerimaan',
  BILLING_ADMIN: 'Administrator',
  PORTAL_PIUTANG: 'SIPAY Piutang',
  PIUTANG_INVOICE: 'Monitoring Invoice',
  PIUTANG_COLLECTION: 'Penagihan dan Status Piutang',
  PIUTANG_CLIENT: 'Data Klien Piutang',
  PIUTANG_SETTINGS: 'Pengaturan Surat Piutang',
}
